import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class ButtonNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On MD Button Pressed';
        this.id = 'node_button';
        this.icon = 'GiClick';
        this.linkedFeature = 'general';
        this.requirements = ['md_button'];

        this.outputs = [
            {
                name: 'Pressed',
                portId: 'on_button_pressed',
                params: [],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const links = project.getNodeLinks(this, 'on_button_pressed');
        if (links.length > 0) {
            const link = links[0];
            let template = `'****${link.getSourceId()}****'`;
            if (project.runtime === 'simulator') {
                blocks.push({
                    location: 'GLOBAL_DECLARATIONS',
                    blockType: BlockType.CODE,
                    id: 'buttonPressedTime',
                    template: `
let buttonPressedTime;
                    `,
                });

                blocks.push({
                    location: 'on_button_pressed',
                    blockType: BlockType.CODE,
                    id: `node_${link.getSourceId()}_pressed_time_init`,
                    template: `
buttonPressedTime = new Date().getTime();`,
                });

                template = `
/****${link.getSourceId()}****/`;

                blocks.push({
                    location: 'RESET_VARIABLES',
                    blockType: BlockType.CODE,
                    template: `
buttonPressedTime = null;`,
                });
            }

            blocks.push({
                location: 'on_button_pressed',
                blockType: BlockType.CODE,
                id: `node_${link.getSourceId()}`,
                template,
            });
        }

        return blocks;
    }

    getDetails(): string {
        return `
This block is triggered when the device's **MD** button is depressed (or the **MD** line is pulled LOW on modules without the button).`;
    }
}
